// Equipment Grid Layout Constants
export const EQUIPMENT_LAYOUT = {
  SLOT_SIZE: 60, // px
  SLOT_GAP: 0.5, // spacing units
  GRID_GAP: 2, // spacing units between grids
  MAIN_GRID_COLS: 3,
  MAIN_GRID_ROWS: 3,
  AUX_GRID_COLS: 1,
  AUX_GRID_ROWS: 3,
};

// Equipment Slot Definitions
export const MAIN_EQUIPMENT_SLOTS = [
  { slot: 'coat', row: 0, col: 0, label: 'Cloak', icon: 'coat' },
  { slot: 'helmet', row: 0, col: 1, label: 'Helmet', icon: 'helmet' },
  { slot: 'ember', row: 0, col: 2, label: 'Ember', icon: 'ember' },
  { slot: 'weapon', row: 1, col: 0, label: 'Weapon', icon: 'weapon' },
  { slot: 'armor', row: 1, col: 1, label: 'Upper Body', icon: 'armor' },
  { slot: 'shield', row: 1, col: 2, label: 'Shield', icon: 'shield' },
  { slot: 'gloves', row: 2, col: 0, label: 'Gloves', icon: 'gloves' },
  { slot: 'legs', row: 2, col: 1, label: 'Lower Body', icon: 'legs' },
  { slot: 'boots', row: 2, col: 2, label: 'Boots', icon: 'boots' },
];

export const AUX_EQUIPMENT_SLOTS = [
  { slot: 'amulet', row: 0, col: 0, label: 'Amulet', icon: 'amulet' },
  { slot: 'ring', row: 1, col: 0, label: 'Ring', icon: 'ring' },
  { slot: 'ring2', row: 2, col: 0, label: 'Ring', icon: 'ring', placeholder: true },
];

// Slot placeholder icons mapping
export const SLOT_PLACEHOLDER_ICONS = {
  'coat': 'cape',
  'helmet': 'rh_26_128',
  'ember': 'ember_slot',
  'weapon': 'rsw_1_128',
  'armor': 'ra_21_128',
  'shield': 'rsh_27_128',
  'gloves': 'rg_1_128',
  'legs': 'rgr_37_128',
  'boots': 'rb_19_128',
  'amulet': 'dl_25_128',
  'accessory': 'frli4_41_128',
  'earring': 'jr_30_128',
  'ring': 'frl4_38_128',
  'default': 'rpl_21_128',
};

// Visual Style Constants
export const EQUIPMENT_STYLES = {
  // Border styles
  BORDER_DEFAULT: '2px',
  BORDER_ERROR: '3px',
  BORDER_RADIUS: '8px',
  
  // Colors
  COLOR_BORDER_ERROR: '#f44336', // Red for missing arrows
  COLOR_EMPTY_OVERLAY: 'rgba(200, 214, 229, 0.7)', // Light blue-gray
  COLOR_TWOHAND_OVERLAY: 'rgba(44, 62, 80, 0.6)', // Dark blue (40% opacity)
  COLOR_QUANTITY_BG: 'rgba(0, 0, 0, 0.7)', // Dark background for quantity
  COLOR_BAG_BG: 'rgb(236, 240, 241)', // Light gray for bag area
  
  // Text styles
  FONT_SIZE_QUANTITY: '12px',
  FONT_FAMILY_QUANTITY: "'JetBrains Mono', monospace",
  FONT_SIZE_STATS: '16px',
  
  // Spacing
  PADDING_QUANTITY: '2px 4px',
  PADDING_STATS_ICON: '4px',
  
  // Icon sizes
  ICON_SIZE_STATS: 16, // px
};

// Stat icons configuration
export const STAT_ICONS = [
  { key: 'attackForce', icon: '/img/inventory.webp', alt: 'Attack Force' },
  { key: 'attackSpeed', icon: '/img/speed.webp', alt: 'Attack Speed' },
  { key: 'criticalRate', icon: '/img/flash.webp', alt: 'Critical Rate' },
  { key: 'criticalForce', icon: '/img/explosion.webp', alt: 'Critical Force' },
  { key: 'accuracy', icon: '/img/accuracy.webp', alt: 'Accuracy' },
  { key: 'evasion', icon: '/img/evasion.webp', alt: 'Evasion' },
  { key: 'armorScore', icon: '/img/shield.webp', alt: 'Armor Score' },
  { key: 'moveSpeed', icon: '/img/sprint.webp', alt: 'Move Speed' },
];